import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import { Button, Empty, Text } from "@/atoms"
import { INTERNAL_EVENTS } from "@/const/event.constants"
import { RANGE_DATE_PICKER_FILTER } from "@/helpers/filters.helper"
import { useAttributesObservable } from "@/hooks/useAttributesObservable"
import { useTranslation } from "@/hooks/useTranslation"
import { NoFound } from "@/icons"
import {
  CONTAINER_SELECTOR,
  FILTER_ATTRIBUTE_NAME,
  LOADING_VALUE
} from "@/templates/TabTemplate"

import styles from "./EmptyTable.module.scss"

import type { EmptyTableComponent } from "."

export const EmptyTable: EmptyTableComponent = (props) => {
  const { containerRef, loading, customEmptyComponent } = props
  const [values, { update }] = useAttributesObservable(containerRef, [
    FILTER_ATTRIBUTE_NAME
  ])
  const counts = values[FILTER_ATTRIBUTE_NAME]
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    update(FILTER_ATTRIBUTE_NAME)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { t } = useTranslation("translation", {
    keyPrefix: "filter.emptyState"
  })

  const from = searchParams.get(RANGE_DATE_PICKER_FILTER.from)
  const to = searchParams.get(RANGE_DATE_PICKER_FILTER.to)
  const isRangeFiltered = !!from && !!to

  if (counts === LOADING_VALUE) return null

  if ((!counts || counts === "0" || loading) && !isRangeFiltered) {
    if (customEmptyComponent) return customEmptyComponent

    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  }

  return (
    <div className={styles.container}>
      <NoFound />
      <Text className={styles.text}>{t("message")}</Text>
      <Button
        type="link"
        onClick={(e) => {
          if (isRangeFiltered) return setSearchParams(new URLSearchParams())
          ;(e.target as HTMLElement)
            .closest(CONTAINER_SELECTOR)
            ?.dispatchEvent(
              new Event(INTERNAL_EVENTS.CLEAR_FILTERS_TABLE_TAB_TEMPLATE)
            )
        }}
      >
        {t("clear")}
      </Button>
    </div>
  )
}
